import { Component, OnInit } from '@angular/core';

@Component({
  template: `<router-outlet></router-outlet>`,
  styles: [
  ]
})
export class UpdateAllPricelistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
